import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1e3a5f] text-white pt-16 pb-8" data-id="element-133">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-135">
          {/* Brand Column */}
          <div className="space-y-4" data-id="element-136">
            <div className="flex items-center space-x-2" data-id="element-137">
              <div className="p-2 bg-white/10 rounded-lg" data-id="element-138">
                <GraduationCap className="h-6 w-6 text-[#f59e0b]" data-id="element-139" />
              </div>
              <span className="text-xl font-bold" data-id="element-140">Study Board</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-141">
              Empowering students to achieve their dreams of international
              education through expert guidance and personalized support.
            </p>
            <div className="flex space-x-4 pt-2" data-id="element-142">
              <a href="#" className="text-gray-400 hover:text-[#f59e0b] transition-colors" data-id="element-143">
                <Facebook className="h-5 w-5" data-id="element-144" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#f59e0b] transition-colors" data-id="element-145">
                <Twitter className="h-5 w-5" data-id="element-146" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#f59e0b] transition-colors" data-id="element-147">
                <Instagram className="h-5 w-5" data-id="element-148" />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#f59e0b] transition-colors" data-id="element-149">
                <Linkedin className="h-5 w-5" data-id="element-150" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-151">
            <h3 className="text-lg font-semibold mb-6 text-[#f59e0b]" data-id="element-152">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-153">
              <li data-id="element-154">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-155">
                  About Us
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-157">
                  Our Services
                </Link>
              </li>
              <li data-id="element-158">
                <Link to="/programs" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-159">
                  Find Programs
                </Link>
              </li>
              <li data-id="element-160">
                <Link to="/apply" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-161">
                  Apply Now
                </Link>
              </li>
              <li data-id="element-162">
                <Link to="/admin" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-163">
                  Admin Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div data-id="element-164">
            <h3 className="text-lg font-semibold mb-6 text-[#f59e0b]" data-id="element-165">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-166">
              <li className="text-gray-300 text-sm" data-id="element-167">University Admissions</li>
              <li className="text-gray-300 text-sm" data-id="element-168">Visa Counseling</li>
              <li className="text-gray-300 text-sm" data-id="element-169">Scholarship Guidance</li>
              <li className="text-gray-300 text-sm" data-id="element-170">Pre-departure Briefing</li>
              <li className="text-gray-300 text-sm" data-id="element-171">Accommodation Support</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-172">
            <h3 className="text-lg font-semibold mb-6 text-[#f59e0b]" data-id="element-173">
              Contact Us
            </h3>
            <ul className="space-y-4" data-id="element-174">
              <li className="flex items-start space-x-3" data-id="element-175">
                <MapPin className="h-5 w-5 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-176" />
                <span className="text-gray-300 text-sm" data-id="element-177">
                  123 Education Plaza, Academic District, New York, NY 10001
                </span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-178">
                <Phone className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-179" />
                <span className="text-gray-300 text-sm" data-id="element-180">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-3" data-id="element-181">
                <Mail className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-182" />
                <a href="mailto:info@studyboard.com" className="text-gray-300 text-sm hover:text-white" data-id="element-183">
                  info@studyboard.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-184">
          <p className="text-gray-400 text-sm text-center md:text-left" data-id="element-185">
            &copy; {new Date().getFullYear()} Study Board. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-186">
            <a href="#" className="text-gray-400 hover:text-white text-sm" data-id="element-187">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm" data-id="element-188">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}